import React from "react"
import { withPrefix } from 'gatsby'
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Newsletter from "../../components/newsletter"
import Scrollspy from 'react-scrollspy'
import { AutoAffix } from 'react-overlays'
import { Link } from '../../components/localizedlink'

import hero from '../../images/contents/hero-iic-white.png';
import heroSm from '../../images/contents/hero-iic-sm-white.png';

const ChampionsPage = ({pageContext: {locale}}) => (
  <Layout locale={locale}>
    <SEO title="Intranet Italia Champions" bodyClass="header-testata site-white" />
    <div className="gradiente">
      <section className="section evento evento--edizione">
        <div className="champions-hero-text">
          <div className="container">
            <div className="row">
              <div className="col-md-10 col-md-offset-1">
                <div className="champions-hero-text__logo">IIC</div>
                <div className="champions-hero-text__edition">First Edition</div>
                <div className="champions-hero-text__title">Intranet Italia <br className="visible-md-block visible-lg-block" />Champions</div>
                <div className="champions-hero-text__subject">The award for the best <br className="visible-md-block visible-lg-block" />Italian intranet projects</div>
                <div className="champions-hero-text__claim">Event created by Giacomo Mason from <a href="https://www.intranetmanagement.it/" title="Intranet Management" target="_blank" rel="noopener noreferrer">Intranet Management</a>,  <br className="d-none d-lg-block" />part of Gruppo <a href="https://www.ariadnedigital.it/" title="Ariadne Digital" target="_blank" rel="noopener noreferrer">Ariadne Digital</a></div>
              </div>
            </div>
          </div>
        </div>
        <picture>
          <source media="(min-width: 768px)" srcSet={hero} />
          <img src={heroSm} alt="INTRANET ITALIA CHAMPIONS" />
        </picture>
      </section>

      <div className="champions">
        <div className="container">
          <div className="row">
            <div id="leftcol" className="hidden-xs col-sm-4 col-md-2 col-md-offset-1">
              <div id="sidebar">
                <AutoAffix affixClassName="affix" topClassName="affix-top" bottomClassName="affix-bottom"
                  container={() => document.getElementById('scrollContainer')}>
                  <div id="leftnav" className="champions__nav nav">
                    <div className="left-nav__primary left-nav__primary--active">What is IIC</div>
                    <nav className="left-nav">
                      <Scrollspy items={['cose', 'partecipa', 'modalita', 'giuria', 'criteri', 'fasi', 'premio']} offset={-20}
                        className="left-nav__list" currentClassName="active">
                        <li className="left-nav__item left-nav__item--1">
                          <a href="#cose" title="What is IIC" className="left-nav__link">The initiative</a>
                        </li>
                        <li className="left-nav__item left-nav__item--2">
                          <a href="#partecipa" title="Your application" className="left-nav__link">Your application</a>
                        </li>
                        <li className="left-nav__item left-nav__item--3">
                          <a href="#modalita" title="How to apply" className="left-nav__link">How to apply</a>
                        </li>
                        <li className="left-nav__item left-nav__item--4">
                          <a href="#giuria" title="Juri" className="left-nav__link">Jury</a>
                        </li>
                        <li className="left-nav__item left-nav__item--5">
                          <a href="#criteri" title="Evaluation criteria" className="left-nav__link">Evaluation criteria</a>
                        </li>
                        <li className="left-nav__item left-nav__item--6">
                          <a href="#fasi" title="Times stages of the prize" className="left-nav__link">Times stages of the prize</a>
                        </li>
                        <li className="left-nav__item left-nav__item--7">
                          <a href="#premio" title="Prize" className="left-nav__link">Prize</a>
                        </li>
                      </Scrollspy>
                    </nav>
                    <div className="left-nav__primary"><Link to="/report-iic-2019/">Report 2019</Link></div>
                    <div className="champions__logo">IIC</div>
                  </div>
                </AutoAffix>
              </div>
            </div>
            <div className="col-sm-8 col-md-6">
              <div className="champions__text" id="scrollContainer">
                <div className="page-section">
                <div>
                  <div className="number">IIC</div>
                  <h1>Intranet Italia Champions:<br/>join us by May 20, 2019!</h1>
                  <div className="intro">
                    Successful initiatives, innovative features, useful contents, effective design, daring experiments: the winner of the first edition of the Intranet Italia Champions could be just your company!
                  </div>
                  <p>
                    Did you manage an innovative project in the field of internal communication last year? 
                  </p>
                  <p>
                    Have you made a good communication initiative or really explosive content inside your intanet? 
                  </p>
                  <p>
                    Have you devised an interesting solution for collaboration, engagement or improvement of internal processes? 
                  </p>
                  <p>
                    Have you created a functional and successful internal application?
                  </p>
                  <p>
                    If you want to share the results with colleagues from other companies, compare yourself and inspire them candidate <strong>your company</strong> for the award!
                  </p>
                  <p>
                    <strong>You don’t need to propose a great project</strong>, just need a small example of implementation within the intranet: information architecture, design, content, design, governance, social functions: in which of these areas have you been practiced?
                  </p>
                  <p>  
                    Share your experience with us and propose your project. A <strong>couple of screenshots</strong> are enough to get started.
                  </p>  
                </div>

                <div id="cose" className="mini-section--top">
                  <h1>What is Intranet Italia Champions?</h1>
                  <div className="intro">
                    The Italia Intranet Champions (IIC) is an annual award given to companies that have implemented on their Intranet an initiative, a content, or an innovative and successful feature for the company and its employees. New ideas, useful and  innovative content (or presented in a new way), engaging and participated initiatives, useful and well-designed services, features and innovative applications that have produced important results for the company and its employees.
                  </div>
                  <p>
                    The Intranet Italia Champions is promoted by <strong><a title="Intranet Management" target="_blank" href="https://www.intranetmanagement.it/" rel="noopener noreferrer">Intranet Management</a></strong>, in collaboration with <strong><a target="_blank" title="Intra2" href="https://intra2.com/" rel="noopener noreferrer">Intra2</a></strong> and <strong><a title="Ariadne Digital" target="_blank" href="https://www.ariadnedigital.it/" rel="noopener noreferrer">Ariadne Digital</a></strong>.
                  </p>
                  <p>The prize concerns a total of 13 companies:</p>
                  <ul>
                    <li>the 3 best projects will receive the 2019 prize</li>
                    <li>the 10 other projects that present elements of interest will be included in the "Intranet Italian Champions 2019" Report, which will be drawn up at the end of the initiative and which will describe in detail the best projects</li>
                  </ul>
                </div>
              </div>
              
              <div id="partecipa" className="page-section">
                <h1>You can submit your application for</h1>
                <p>
                  The international jury of the Intranet Italia Champions will evaluate single <strong>features</strong>, <strong>contents</strong> or <strong>online services</strong> that make the difference within the organization and the intranet. The following elements (listed in non-exhaustive way) will then be taken into consideration:
                </p>
                <div className="row">
                  <div className="col-sm-6">
                    <h2>Contents</h2>
                    <p>
                      Contents expecially useful, relevant, innovative or presented in a new way - for example: news, notices,documents, FAQs, infographics, information sheets (products, offices, people, sectors, etc.), video gallery, well-made training contents distributed via intranet on the various media (desktop, tablet, mobile, digital signage)
                    </p>
                  </div>
                  <div className="col-sm-6">
                    <h2>Initiatives</h2>
                    <p>
                      Special initiatives that have involved the company people in participatory modalities (e.g.: idea management, contest, crowdsourcing, community, Q&A etc.)
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <h2>Functionalities</h2>
                    <p>
                      Innovative features with advanced design, such as: search systems, notification systems, filter systems, ways of interacting with employees, advanced profiling systems, personalization systems, personal pages, etc ...
                    </p>
                  </div>
                  <div className="col-sm-6">
                    <h2>Online services</h2>
                    <p>Online services particularly advanced and useful for the corporate people with advanced design, such as: booking rooms, purchase equipment, ticketing systems, approval workflow, search for people, etc ...</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <h2>Internal online applications</h2>
                    <p>
                      Useful, well designed, innovative and well integrated applications with the intranet, such as: HR applications, online training, business applications, order and warehouse management, etc ...
                    </p>
                  </div>
                </div>
              </div>
              
              <div id="modalita" className="page-section">
                <h1>How to apply</h1>
                <div className="mini-section">
                  <div className="number">1</div>
                  <p>Candidates must send an email by May 20, 2019 to the following address:
                    <strong> <a href="mailto:IIC@intranetitaliaday.it">IIC@intranetitaliaday.it</a></strong>
                  </p>
                </div>
                <div>
                  <div className="number">2</div>
                  <p>The email must contain:</p>
                  <div className="check check--first">
                    Company name and number of members of the project/initiative
                  </div>
                  <div className="check">
                    A description of the purpose, context of use, operations and elements most relevant for the content/initiative/ feature nominated for the prize
                  </div>
                  <div className="check">
                    <strong>Minimum two high</strong> resolution screenshots of the content/initiative/feature nominated for the prize
                  </div>
                </div>
                <div>
                  <div className="number">3</div>
                  <p>
                    If the application is deemed to be interesting, a member of the evaluation team will contact the company for an in-depth interview in order to examine the relevant points for well understanding the project, for example:
                  </p>
                  <div className="check check--first">technology;</div>
                  <div className="check">governance model</div>
                  <div className="check">in depth analysis of the intranet that hosts contents/initiative/functionality nominated</div>
                  <div className="check">process of realization of the content/initiative/functionality nominated (e.g. employee involvement, user centered design techniques, development sprints, etc ...)</div>
                  <div className="check">results achieved and ROI achieved through the content/initiative/functionality that is nominated</div>
                  <div className="check">lessons learned</div>
                </div>
                <div>
                  <div className="number">4</div>
                  <p>At the end of the selection process, all companies will be contacted by e-mail and the result of the evaluation will be communicated:</p>
                  <ul>
                    <li>winning project</li>
                    <li>project not winner but included among the cases in the Intranet Italia Champions 2019 Report</li>
                    <li>excluded project</li>
                  </ul>
                </div>
              </div>

              <div id="giuria" className="page-section">
                  <h1>Jury</h1>
                  <div className="intro">
                    The Italia Champions Intranet prize will be awarded by a jury of Italian and foreign intranet and communication experts:
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <Link to="/giacomo-mason/" className="person__link">
                        <div className="person">
                          <img src={withPrefix('/images/contents/Giacomo_Mason.jpg')} alt="Giacomo Mason" className="person__img" />
                          <span className="person__name">Giacomo Mason</span>
                          <span className="person__role">Consultant, founder at Intranet Management</span>
                        </div>
                      </Link>
                    </div>
                    <div className="col-sm-4">
                      <Link to="https://www.linkedin.com/in/alessandra-mazzei-b365b96/" className="person__link">
                        <div className="person">
                          <img src={withPrefix('/images/contents/Alessandra-Mazzei.jpg')} alt="Alessandra Mazzei" className="person__img" />
                          <span className="person__name">Alessandra Mazzei</span>
                          <span className="person__role">Director of Centre Employee Relations and Communication</span>
                        </div>
                      </Link>
                    </div>
                    <div className="col-sm-4">
                      <Link to="https://www.linkedin.com/in/marco-stancati-comunicatore-/?originalSubdomain=it" className="person__link">
                        <div className="person">
                          <img src={withPrefix('/images/contents/Marco-Stancati.jpg')} alt="Marco Stancati" className="person__img" />
                          <span className="person__name">Marco Stancati</span>
                          <span className="person__role">Consultant and Professor of Communication at the Sapienza University of Rome</span>
                        </div>
                      </Link>
                    </div>
                    <div className="col-sm-4">
                      <Link to="/elena-bogdanova/" className="person__link">
                        <div className="person">
                          <img src={withPrefix('/images/contents/elena-bogdanova.jpg')} alt="Elena Bogdanova" className="person__img" />
                          <span className="person__name">Elena Bogdanova</span>
                          <span className="person__role">Intranet consultant, founder of Rivelty.Intranet</span>
                        </div>
                      </Link>
                    </div>
                    <div className="col-sm-4">
                      <Link to="/mads-richard/" className="person__link">
                        <div className="person">
                          <img src={withPrefix('/images/contents/Mads_Richard.png')} alt="Mads Richard" className="person__img" />
                          <span className="person__name">Mads Richard</span>
                          <span className="person__role">Intranet and digital workplace consultant and facilitator at Intra2</span>
                        </div>
                      </Link>
                    </div>
                    <div className="col-sm-4">
                      <Link to="/martin-white/" className="person__link">
                        <div className="person">
                          <img src={withPrefix('/images/contents/Martin-White.jpg')} alt="Martin White" className="person__img" />
                          <span className="person__name">Martin White</span>
                          <span className="person__role">Managing Director of Intranet Focus</span>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>

              <div id="criteri" className="page-section">
                <h1>Evaluation criteria</h1>
                <div className="intro">The projects will be evaluated by a team of design, usability and intranet management italian and foreign professionals:</div>
                <p>The following elements will be considered in particular:</p>
                <ul>
                  <li>Design innovativeness and respect for international usability and user experience standards (25%)</li>
                  <li>Ability to respond to the needs of employees (25%)</li>
                  <li>Innovativeness in design and respect for international usability and user experience standards (10%)</li>
                  <li>Employee involvement in the analysis-project-realization phase and user centerd design techniques (20%)</li>
                  <li>Results achieved, exposed explicitly and verifiably (20%)</li>
                </ul>
              </div>

              <div id="fasi" className="page-section">
                <h1>Times stages of the prize</h1>
                <div className="timeline">
                  <div className="timeline__box">
                    <div className="timeline__date">from December 10th, 2018 to May 20th, 2019</div>
                    <div>Submission of material by the candidate companies</div>
                  </div>
                  <div className="timeline__box">
                    <div className="timeline__date">May 30th, 2019</div>
                    <div>Depth Analysis and interviews</div>
                  </div>
                  <div className="timeline__box">
                    <div className="timeline__date">by June 30th, 2019</div>
                    <div>Selection of winners and proclamation</div>
                  </div>
                  <div className="timeline__box">
                    <div className="timeline__date">September 1th, 2019</div>
                    <div>Publication of the Report</div>
                  </div>
                  <div className="timeline__box timeline__box--last">
                    <div className="timeline__date">October 10th, 2019</div>
                    <div>Public meeting with the winners</div>
                  </div>
                </div>
              </div>
              
              <div id="premio" className="page-section">
                <h1>Prize</h1>
                <p>The prize for the 3 winners will be:</p>
                <ul>
                  <li>the IIC 2019 trophy, presented during the award ceremony at the IID 2019</li>
                  <li>a free copy of the <strong>IIC 2019 Report</strong> (in ITA and ENG)</li>
                  <li><strong>free entry</strong> for 2 people to IID 2019</li>
                  <li><strong>free access</strong> to the <strong><a title="Intra2" target="_blank" href="https://intra2.com/" rel="noopener noreferrer">Intra2</a></strong> platform for worldwide sharing of screenshots and intranet experiences</li>
                </ul>
                <p>The non-winning but deemed worthy of nomination will be published in the IIC 2019 Report and the companies will be awarded with:</p>
                <ul>
                  <li>a <strong>free copy</strong> of the IIC 2019 Report (in ITA and ENG)</li>
                  <li><strong>free entry</strong> for 1 person to IID 2019</li>
                  <li><strong>3 months free access</strong> to the <strong><a title="Intra2" target="_blank" href="https://intra2.com/" rel="noopener noreferrer">Intra2</a></strong> platform for worldwide sharing of screenshots and intranet experiences</li>
                </ul>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Newsletter />
    </div>
  </Layout >
)

export default ChampionsPage;